<template>
  <div class="content">
    <h1>Bulk discount</h1>

    <div
      v-if="!uploaded"
      class="margin-bottom margin-top">
      <h3 class="margin-top">Discount</h3>
      <MaterialText
        v-model="form.discount_id"
        label="Discount ID"
        />

      <h3 class="margin-top">Exported customer data</h3>
      <p>
        The format is the one used in CSV exports from Klaviyo.
        <br />
        There must be one customer per line.
        <br />
        The data points must be separated by comma (,)
        <br />
        The customer ID must be present, otherwise the customer account cannot be located.
        <br />
        Any information other than the customer ID will be ignored, but can be left in, if you find that more convenient.
      </p>
      <textarea
        style="width: 500px; height: 200px;"
        placeholder="name@email.com,123456,First,Last"
        class="margin-bottom"
        v-model="form.data"></textarea>
      <div>
        <button
          v-on:click="submit"
          :disabled="saving || !form.data || !form.discount_id">Upload</button>
      </div>
    </div>

    <div
      v-if="saving || uploaded"
      class="margin-top">
      <template v-if="saving">Upload...</template>
      <template v-else>
        <button
          v-on:click="reset">Reset</button>

        <div
          class="margin-bottom margin-top">Successfully added: <strong>{{ uploaded.successful }}</strong></div>

        <template v-if="uploaded.errors.length === 0">No errors</template>
        <template v-else>
          <div
            class="small-margin-bottom"
            v-for="err in uploaded.errors">
            {{ err.error }}
            <em><div>on line: {{ err.line }}</div></em>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  data: () => ({
    data: {},
    saving: false,
    form: {
      data: '',
      discount_id: ''
    },
    uploaded: null
  }),
  methods: {
    submit () {
      Vue.$api.post('/discount/bulk', this.form, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.uploaded = data
      })
    },
    reset () {
      this.uploaded = null
      this.form.data = ''
      this.form.discount_id = ''
    }
  }
}
</script>
